import React, { Fragment, useState } from 'react'
// import { data } from 'react-router-dom'
// import data from '../femcare-content.json';
import HeroSection from '../components/common/HeroSection';
import CTASection from '../components/common/CTASection';
import ConditionsGrid from '../components/Conditions/ConditionsCard';
import conditionsData from '../conditions.json'
import DigitalHealthFAB from '../components/Digitalhealth';

const { slides } = conditionsData.conditions.hero;
const { hero } = conditionsData.conditions;

const { callToAction } = conditionsData;

const Conditions = () => {
  const [query, setQuery] = useState('');
  return (
    <Fragment>
      <div 
      // style={{ backgroundColor: '#F4F6FA' }}
      >
        <DigitalHealthFAB/>
        {/* <HeroSection slides={hero.slides} /> */}
        <HeroSection slides={slides} />
        <div className="w-full ava-section-gap">
          <ConditionsGrid query={query} />
        </div>
        {/* <div style={{ backgroundColor: '#F4F6FA' }}> */}
        <CTASection data={callToAction} />
        {/* </div> */}
      </div>

    </Fragment>
  )
}

export default Conditions